import defaults from './defaults.json';
export type PageId = keyof typeof defaults;
export const pageIds = ["home", "services", "packages", "portfolio", "about", "contact", "booking", "footer"] as PageId[];
let content = structuredClone(defaults);
export const getContent = <K extends PageId>(page: K): typeof defaults[K] => content[page];
export function setContent<K extends PageId>(page: K, value: typeof defaults[K]) { content = { ...content, [page]: { ...defaults[page], ...value } }; }
export { defaults };
